// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

import AnimateHeadline from "./components/Headline";

jQuery(function ($) {
    $('header ul > li > a').click(function () {
        $('header ul li').removeClass('active');
        $(this).parent().addClass('active');
    });

    $(window).load(function () {

        var offsetChange = 7;

        var home = $('.image-cover.green').offset().top;
        var people = $('.image-cover.green-2').offset().top - offsetChange;
        var businessAreas = $('.image-cover.green-3').offset().top - offsetChange;
        var joinUs = $('a[name="join-us"]').offset().top - offsetChange;
        var credentials = $('a[name="credentials"]').offset().top - offsetChange;
        var runningClub = $('.image-cover.green-4').offset().top - offsetChange;
        var contactUs = $('.visit-us').offset().top;


        $(window).resize(function () {
            home = $('.image-cover.green').offset().top;
            people = $('.image-cover.green-2').offset().top - offsetChange;
            businessAreas = $('.image-cover.green-3').offset().top - offsetChange;
            joinUs = $('a[name="join-us"]').offset().top - offsetChange;
            credentials = $('a[name="credentials"]').offset().top - offsetChange;
            runningClub = $('.image-cover.green-4').offset().top - offsetChange;
            contactUs = $('.visit-us').offset().top;
        });

        $(window).scroll(position => {
            var scroll = $(window).scrollTop();

            if (scroll > home && scroll < people) {
                changeClass('green');
                menuActiveClass('home');
            }

            if (scroll > people && scroll < businessAreas) {
                changeClass('green2');
                menuActiveClass('people');
            }

            if (scroll > businessAreas && scroll < runningClub) {
                changeClass('green3');
            }


            if (scroll > businessAreas && scroll < joinUs) {
                menuActiveClass('business-areas');
            }

            if (scroll > joinUs && scroll < credentials) {
                menuActiveClass('join-us');
            }

            if (scroll > credentials && scroll < runningClub) {
                menuActiveClass('credentials');
            }

            if (scroll > runningClub && scroll < contactUs) {
                changeClass('green4');
                menuActiveClass('running-club');
            }

            if (scroll > contactUs) {
                changeClass('green5');
                menuActiveClass('contact-us');
            }

            /* $('header ul li a').each(function () {
                var currLink = $(this);
                var target = currLink.attr('href').replace('#', '');
                var refElement = $('a[name="' + target + '"]');
                if (refElement.position().top <= scroll && refElement.position().top + refElement.height() > scroll) {
                    $('header ul li a').removeClass("active");
                    currLink.parent().addClass("active");
                    console.log(target + " is active");
                }
                else {
                    currLink.parent().removeClass("active");
                    console.log("remove class");
                }
                console.log("Seraching for " + target + " it has position " + refElement.position().top);
            }); */

        })

        function changeClass(currentClass) {
            $('header').removeClass(['green', 'green2', 'green3', 'green4', 'green5']).addClass(currentClass);
        }

        function menuActiveClass(name) {
            //window.location.hash = name;
            $('header ul li').removeClass('active');
            $('header ul li a[href="#' + name + '"]').parent().addClass('active');
        }

    });

});